import { render } from "./Loading.vue?vue&type=template&id=d7d1f134&scoped=true"
import script from "./Loading.vue?vue&type=script&lang=ts"
export * from "./Loading.vue?vue&type=script&lang=ts"

import "./Loading.vue?vue&type=style&index=0&id=d7d1f134&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-d7d1f134"

export default script